module.exports = __webpack_public_path__ + "a6959fb12c52c01b9b6e3cd8f526d0cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-clover.png
// module id = 2434
// module chunks = 0